// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__minervaModern_a4b13f', '__minervaModern_Fallback_a4b13f'"},"className":"__className_a4b13f","variable":"__variable_a4b13f"};